import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// api
import * as courseAPI from 'api/schoolBasedActivity';
import {
  add_v2_params,
  get_course_level_params,
  get_list_v2_params,
  get_params,
  update_course_publish_status_params,
  get_course_tab_count_list_params,
  delete_course_params,
  batch_delete_course_params,
  batch_archive_params,
  get_progress_by_course_id_params,
  get_progress_by_class_id_params,
  get_student_progress_params
} from 'types/schoolBasedActivity';

// ----------------------------------------------------------------------

type schoolBaseActivity = {
  loading: boolean;
  addPage: { stepperForm1: {}; stepperForm2: {} };
  addResId: string;
  courseList: { rows: any[]; total: number };
  courseLevelPanelList: { rows: any[]; total: number };
  courseId: {};
  tabCountList: [];
  viewState: {};
  classList: { student_list: [] };
  studentStoryList: {
    list: [];
  };
};

const initialState: schoolBaseActivity = {
  loading: false,
  addPage: { stepperForm1: {}, stepperForm2: {} },
  addResId: '',
  courseList: { rows: [], total: -1 },
  courseLevelPanelList: { rows: [], total: -1 },
  courseId: {},
  tabCountList: [],
  viewState: {},
  classList: { student_list: [] },
  studentStoryList: {
    list: []
  }
};

const slice = createSlice({
  name: 'schoolBasedActivity',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
    },
    stopLoading(state) {
      state.loading = false;
    },
    setStepperFormData(state, action) {
      const { pageField, data } = action.payload;
      state.loading = false;
      state.addPage = { ...state.addPage, [pageField]: data };
    },
    setAddResId(state, action) {
      state.loading = false;
      state.addResId = action.payload;
    },
    setCourseList(state, action) {
      state.loading = false;
      state.courseList = action.payload;
    },
    setCourseLevelPanel(state, action) {
      state.loading = false;
      state.courseLevelPanelList = action.payload;
    },
    setCourseId(state, action) {
      state.loading = false;
      state.courseId = action.payload;
    },
    setTabCountList(state, action) {
      state.loading = false;
      state.tabCountList = action.payload;
    },
    setViewState(state, action) {
      state.loading = false;
      state.viewState = action.payload;
    },
    setClassList(state, action) {
      state.loading = false;
      state.classList = action.payload;
    },
    setStudentStoryList(state, action) {
      state.loading = false;
      state.studentStoryList = action.payload;
    },

    resetViewState(state, action) {
      state.loading = false;
      state.viewState = {};
      // state.courseId = {};
    },
    resetClassList(state, action) {
      state.loading = false;
      state.classList = { student_list: [] };
      state.courseId = {};
    },
    resetStudentStoryList(state, action) {
      state.loading = false;
      state.studentStoryList = { list: [] };
      state.courseId = {};
    },
    clearStepperFormData(state) {
      state.loading = false;
      state.addPage = { stepperForm1: {}, stepperForm2: {} };
      state.addResId = '';
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
// Actions
export const {
  startLoading,
  setStepperFormData,
  setAddResId,
  clearStepperFormData,
  resetViewState,
  resetClassList,
  resetStudentStoryList,
  stopLoading
} = slice.actions;

// action

// 新增校本课程
export function add_v2(params: add_v2_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, is_folder } = params;
    try {
      const response = await courseAPI.add_v2(params);
      console.log(response);

      if (is_folder !== '1') {
        dispatch(slice.actions.setAddResId(response));
      }

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    } finally {
      // dispatch(slice.actions.stopLoading());
    }
  };
}

// 獲取新增校本課程題目
export function get_course_level(params: get_course_level_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback } = params;
    try {
      const response = await courseAPI.get_course_level(params);
      console.log(response);

      if (callback) {
        callback(response);
      }

      dispatch(slice.actions.setCourseLevelPanel(response));
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// 獲取校本列表
export function get_list_v2(params: get_list_v2_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, finalCallback } = params;
    try {
      const response = await courseAPI.get_list_v2(params);
      console.log(response);
      if (callback) {
        callback(response);
      }
      if (!Array.isArray(response?.rows)) {
        return;
      }

      dispatch(slice.actions.setCourseList(response));
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    } finally {
      if (finalCallback) {
        finalCallback();
      }
    }
  };
}

// 獲取id对应的校本课程信息
export function get(params: get_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback } = params;
    console.log(params);
    try {
      const response = await courseAPI.get(params);
      console.log(response);

      if (callback) {
        callback(response);
      }

      dispatch(slice.actions.setCourseId(response));
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// 編輯保存
export function update_course_publish_status(params: update_course_publish_status_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback } = params;
    console.log(params);
    try {
      const response = await courseAPI.update_course_publish_status(params);
      console.log(response);

      if (callback) {
        callback(response);
      }

      // dispatch(slice.actions.setCourseId(response));
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// 列表tips
export function get_course_tab_count_list(params: get_course_tab_count_list_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback } = params;
    console.log(params);
    try {
      const response = await courseAPI.get_course_tab_count_list(params);
      console.log(response);

      dispatch(slice.actions.setTabCountList(response));

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// 刪除
export function delete_course(params: delete_course_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback } = params;
    console.log(params);
    try {
      const response = await courseAPI.delete_course(params);
      console.log(response);

      // dispatch(slice.actions.setTabCountList(response));

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// 批量刪除
export function batch_delete_course(params: batch_delete_course_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback } = params;

    try {
      const response = await courseAPI.batch_delete_course(params);
      console.log(response);

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// slices 文件
export function batch_archive(params: batch_archive_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, ...rest } = params;
    console.log(params);
    try {
      const response = await courseAPI.batch_archive(rest);
      console.log(response);

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// 浏览情况
export function get_progress_by_course_id(params: get_progress_by_course_id_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, ...rest } = params;
    try {
      const response = await courseAPI.get_progress_by_course_id(rest);
      dispatch(slice.actions.setViewState(response));

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// 浏览情况-班級
export function get_progress_by_class_id(params: get_progress_by_class_id_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, ...rest } = params;
    try {
      const response = await courseAPI.get_progress_by_class_id(rest);
      if (Array.isArray(response?.student_list)) {
        dispatch(slice.actions.setClassList(response));
      }
      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// 浏览情况-班級-学生
export function get_student_progress(params: get_student_progress_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, ...rest } = params;
    try {
      const response = await courseAPI.get_student_progress(rest);
      // console.log(response);

      if (Array.isArray(response?.list)) {
        dispatch(slice.actions.setStudentStoryList(response));
      }
      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}
